<script>
import { mapActions } from 'vuex';

import LoadingSpinner from "../../../components/LoadingSpinner.vue";

export default {
    components: {
        LoadingSpinner,
    },

    data() {
        return {
            auditorCompany: null,
            auditorCompanies: [],

            loadingNewAuditor: false,
        }
    },

    mounted() {
        this._getAuditorByAuditedCompany();
    },

    methods: {
        ...mapActions('auditor', [
            'getAuditorByAuditedCompany',
            'getAuditorCompanies',
            'changeAuditorCompany',
            'createAuditorRelationRequest',
        ]),

        _getAuditorByAuditedCompany() {
            this.getAuditorByAuditedCompany()
                .then((response) => {
                    if (response.status === 200) {
                        this.auditorCompany = response.data;
                    } else if (response.status === 203) {
                        this._getAuditorCompanies();
                    }
                })
                .catch(({ response }) => {
                    console.error(response);
                })
        },

        _getAuditorCompanies() {
            if (this.auditorCompanies.length === 0) {
                this.getAuditorCompanies()
                    .then((response) => {
                        this.auditorCompanies = response.data;
                    })
                    .catch(({ response }) => {
                        console.error(response);
                    })
            }
        },

        _changeAuditorCompany(company) {
            const params = {
                audited_company_id: this.$user.company_id,
                auditor_company_id: company.company_id,
                created_by:  this.$user.user_id,
            }

            this.changeAuditorCompany(params)
                .then(response => {
                    this.loadingNewAuditor = true;

                    const replaceIndex = this.auditorCompanies.findIndex(x => x.company_id === company.company_id);
                    this.auditorCompanies[replaceIndex] = this.auditorCompany;

                    this.auditorCompany = company;
                    this.$notify('success', response.data.messageName);
                    setTimeout(() => {
                        this.loadingNewAuditor = false;
                        this.$refs.listOfAuditors.closePopup();
                    }, 500);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        _createAuditorRelationRequest(company) {
            const params = {
                audited_company_id: this.$user.company_id,
                auditor_company_id: company.company_id
            }

            this.createAuditorRelationRequest(params)
                .then(response => {
                    this.loadingNewAuditor = true;

                    const replaceIndex = this.auditorCompanies.findIndex(x => x.company_id === company.company_id);
                    this.auditorCompanies[replaceIndex].is_pending = true;
                    this.$notify('success', response.data.messageName);
                    setTimeout(() => {
                        this.loadingNewAuditor = false;
                        this.$refs.listOfAuditors.closePopup();
                    }, 500);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        clickShowAuditors() {
            this._getAuditorCompanies();
            this.$refs.listOfAuditors.openPopup();
        }
    }
}
</script>

<template>
    <div class="auditor-list-component">
        <div class="inner-list-wrapper" v-if="auditorCompany">
            <div class="declared-auditor">
                {{ $t('auditor.list.auditor_company') }}: <b>{{ auditorCompany.company_name }}</b>.
            </div>
            <div class="see-list" tabindex="0" @click="clickShowAuditors()" @keyup.enter="clickShowAuditors()">
                {{ $t('auditor.list.see_other_auditors') }}
            </div>
        </div>

        <div class="inner-list-wrapper" v-else>
            <div class="declared-auditor">
                {{ $t('auditor.list.no_auditor') }}
            </div>
            <div class="see-list" tabindex="0" @click="clickShowAuditors()" @keyup.enter="clickShowAuditors()">
                {{ $t('auditor.list.see_all_auditors') }}
            </div>
        </div>

        <sust-popup ref="listOfAuditors" size="sm" title="" :footer="false">
            <div class="auditor-companies" v-if="auditorCompanies.length > 0 && loadingNewAuditor == false">
                <div class="auditor-company" v-for="item in auditorCompanies" :key="item.company_id">
                    <div>
                        {{ item.company_name }}
                    </div>
                    <button class="select-company-button" @click="_createAuditorRelationRequest(item)" :disabled="item.is_pending">
                        {{ !item.is_pending ? $t('auditor.list.select') : $t('auditor.list.pending') }}
                    </button>
                </div>
            </div>

            <div v-if="loadingNewAuditor == true" class="flex-all-centered-row" style="padding: 1em; font-size: 2em; text-align: center;">
                <LoadingSpinner />
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
.auditor-list-component {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    >.inner-list-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        >div {
            padding: .25em;

            >b {
                color: black;
                font-weight: bolder;
                text-decoration: underline;
            }
        }

        >.see-list {
            color: black;
            font-weight: bold;
            cursor: pointer;

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }
}

.auditor-companies {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    > .auditor-company {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;

        padding: .5em 0;
        border-bottom: thin solid lightgray;

        > div {
            flex: 3;
            text-align: end;
            padding-right: 1em;
        }

        > button {
            flex: 1
        }
    }
}

.select-company-button {
    background-color: var(--sustainfinity-faded-blue);
    color: var(--sustainfinity-blue);
    outline: thin solid var(--sustainfinity-green) !important;
    border-radius: .25em;
    border: 0;
    padding: .25em 1.5em;
    margin: auto;

    &:focus {
        outline: .15em solid var(--sustainfinity-green) !important;
    }

    &:active {
        outline: .15em solid var(--sustainfinity-green) !important;
        scale: .95;
    }
}
</style>